export const winnersAssets = {
	header: {
		background: "/spec_winners/desktop-bg.png",
		characters: "/spec_winners/title-characters.png"
	}
} as const;
